export default {
  "header": {
    "CHANGE_PASSWORD": "更改密碼",
    "CHANGE_STATION": "切換工位號碼",
    "CHANGE_SETTING": "設定",
    "CLICK_ON": "點擊展開",
    "CLICK_ON_THE_FOLD": "點擊收起",
    "CURRENT_PASSWORD": "當前密碼",
    "FAILED_UPDATE_TASK_LIST": "更新任務列表失敗",
    "LOGOUT": "登出",
    "MSG_ENTER_CURRENT_PASSWORD": "請輸入當前密碼",
    "MSG_ENTER_NEW_PASSWORD": "請輸入新密碼",
    "MSG_NEW_PASSWORD_NOT_MATCH": "新密碼不匹配",
    "MSG_PASSWORD_UPDATED": "您的密碼已成功更新，請使用新密碼登錄",
    "NEW_PASSWORD": "新密碼",
    "NEW_PASSWORD_AGAIN": "確認新密碼",
    "SELECT_CLIENT_TO_SWITCH": "選擇客戶",
    "SWITCH_CLIENT": "切換客戶端",
    "SWITCHED_TO_CLIENT": "切換到客戶",
    "TASK_LIST": "任務列表",
    "UPDATE_PASSWORD": "更新密碼",
    "USER_PROFILE": "用戶配置",
    "DIM_WEIGHT_ADDRESS": "Dim Weight 機位址",
    "MSG_SETTING_UPDATED_SUCCESS": "設置保存成功, 請重新整理頁面確保更新套用",
    "WEIGHT_MODE": "稱重模式",
    "WEIGHT_MODE_NONE": "無 (手動輸入)",
    "WEIGHT_MODE_LOCAL": "本地 (WebApp Hardware Bridge)",
    "WEIGHT_MODE_DIM_WEIGHT": "Dim Weight 機 (內網)",
    "SAVE": "保存"
  },
  "login": {
    "EMAIL": "電郵",
    "ERROR_EMPTY_PASSWORD": "密碼不能為空",
    "INFO_LOGIN_SUCCESS": "登錄成功",
    "LOGIN_INCORRECT": "登錄失敗, 使用者名稱或密碼不正確",
    "MFA_CODE": "驗證碼",
    "MFA_INVALID": "不正確的驗證碼, 請重新輸入",
    "MFA_REQUIRED": "需要輸入驗證碼, 請透過登記的手機 SMS 或 OTP 接收",
    "PASSWORD": "密碼",
    "RESET": "重設",
    "SUBMIT": "登入",
    "SWITCHING_CLIENT": "正在切換客戶，請稍候...",
    "USERNAME": "用戶名"
  },
  "menu": {
    "DASHBOARD": "儀表板",
    "INBOUND_AND_OUTBOUND": "出入庫統計",
    "OPERATION_INBOUND": "入倉掃描",
    "OPERATION_MANUAL_SORT": "手動分揀入倉",
    "OPERATION_LOCKER_RETURN_INBOUND": "自助櫃退件回件入倉",
    "DEST_PICKUP_INBOUND":"目的地取件分揀入倉",
    "PY_RETURN_INBOUND":"五聯單回件入倉",
    "OPERATION_MANUAL_OUTBOUND": "手動分揀出倉",
    "OPERATION_MANUAL_CLOSE_BOX": "封箱及移交",
    "OPERATION_OUTBOUND": "出庫",
    "OPERATION_RETURN": "回倉掃描",
    "PROBLEM_WAREHOUSE":'問題件倉存',
    "OPERATION_CONSOLIDATION": "集貨",
    "OPERATION_CHECK": "查單",
    "VOLUME_BY_SORT_CODE": "路線貨量統計",
    "MANUAL_SORTING": "手動分揀",
    "AUTO_SORTER": "自動分揀機",
    "AUTO_SORTER_DASHBOARD": "儀表板",
    "AUTO_SORTER_CONTROL_PANEL": "操作面板",
    "AUTO_SORTER_PROFILES": "分揀邏輯",
    "DHL_ITEM_SORTING":"DHL項目分揀",
    "INBOUND_PACKAGE_HANDING":"入庫包裹處理",
    "COLLECTION":"攬收",
    "PY_SORT_INBOUND":"五聯單分揀入倉",
    "HANDOVER_REPORT":"報告",
    "ORDERINFO":"查訂單資料",
  }
}



// WEBPACK FOOTER //
// ./src/i18n/langs/zh-HK.js